"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.PaginationWrapper = exports.CarouselWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridContainer = require("../grid-container");

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = (0, _styledComponents["default"])(_gridContainer.GridContainer).withConfig({
  displayName: "carouselSectionstyles__Wrapper",
  componentId: "sc-13r47r1-0"
})(["width:100%;padding:64px 0;"]);
exports.Wrapper = Wrapper;
var CarouselWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "carouselSectionstyles__CarouselWrapper",
  componentId: "sc-13r47r1-1"
})(["grid-column:main-start / main-end;"]);
exports.CarouselWrapper = CarouselWrapper;
var PaginationWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "carouselSectionstyles__PaginationWrapper",
  componentId: "sc-13r47r1-2"
})(["grid-column:main-start / main-end;display:flex;justify-content:center;padding-top:24px;"]);
exports.PaginationWrapper = PaginationWrapper;
var Title = (0, _styledComponents["default"])(_typography.Title).withConfig({
  displayName: "carouselSectionstyles__Title",
  componentId: "sc-13r47r1-3"
})(["grid-column:main-start / main-end;padding-bottom:24px;@media ", "{padding-bottom:36px;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.Title = Title;